<div class="container-fluid service-bg from-top-pad">
    <!-- Titles -->
    <div class="row">
        <div class="col-md-12">
            <h1>
                <a href="#/account">{{'gen_my_account' | translate}}</a> / {{'account_change_email' | translate}}
            </h1>
            <hr>
        </div>
    </div>

    <!-- Email Form -->
    <div class="row" *ngIf="!verifyPinStep">
        <div class="col-md-12">
            <p class="text-center"> {{'account_change_email_msg' | translate}} </p>

            <!-- Form -->
            <div class="form-group mx-auto login-form mt-0" [formGroup]="mailGroup">
                <mat-form-field class="form-element" appearance="fill">
                    <mat-label>{{'gen_email' | translate}}</mat-label>
                    <input [type]="'email'" matInput placeholder="{{'gen_email' | translate}}" formControlName="email">

                    <!-- Errors -->
                    <mat-error *ngIf="mailGroup.controls.email.errors?.required">{{'error_required_error' | translate}}
                    </mat-error>
                    <mat-error *ngIf="mailGroup.controls.email.errors?.pattern">{{'error_email_invalid' | translate}}
                    </mat-error>
                </mat-form-field>

                <button class="button w-100" (click)="changeEmail()"
                    [disabled]="mailGroup.controls.email.status == 'INVALID'">
                    <i class="pr-1 fa fa-at"></i>
                    {{'account_change_email' | translate}}
                </button>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="verifyPinStep">
        <div class="col-md-12">
            <!-- Verification PIN -->
            <div class="text-center">
                <h3>{{'lf_register_step2_msg' | translate}}</h3>

                <p> {{'lf_register_pin_msg' | translate:{ email: mailGroup.controls.email.value} }} </p>

                <!-- Count Down Message -->
                <p *ngIf="countDown > 0">
                    {{'lf_register_pin_msg_2' | translate}} {{countDownTime}}
                    <mat-progress-spinner class="count-down" [color]="'primary'" [mode]="'determinate'" [diameter]="30"
                        [value]="countDown">
                    </mat-progress-spinner>
                </p>

                <!-- Expiration Message -->
                <p *ngIf="countDown <=0"> {{'lf_register_expire_pin_msg' | translate}}
                    <span class="cursor-po-c text-danger" (click)="changeEmail()">{{'lf_register_pin_try_again' |
                        translate}}</span>
                </p>
            </div>


            <!-- Verification PIN Form -->
            <div class="form-group mx-auto login-form" [formGroup]="mailGroup">
                <!-- Old Pin -->
                <mat-form-field class="form-element" appearance="fill">
                    <mat-label>{{'gen_email_old_pin' | translate}}</mat-label>
                    <textarea class="in-text-areas" matInput formControlName="oldPin"
                        placeholder="{{'gen_email_old_pin' | translate}}"></textarea>
                </mat-form-field>

                <!-- New Pin -->
                <mat-form-field class="form-element" appearance="fill">
                    <mat-label>{{'gen_email_pin' | translate}}</mat-label>
                    <textarea class="in-text-areas" matInput formControlName="pin"
                        placeholder="{{'gen_email_pin' | translate}}"></textarea>
                </mat-form-field>

                <!--Button -->
                <button class="button w-100" (click)="validatePin()"
                    [disabled]="mailGroup.controls.pin.status == 'INVALID' || mailGroup.controls.oldPin.status == 'INVALID'">
                    <i class="pr-1 fa fa-at"></i>
                    {{'lf_email_pin_btn' | translate}}
                </button>

                <div class="text-center mt-3">
                    <p>{{'lf_register_pin_try_again_msg' | translate}}</p>
                    <p class="cursor-po-c text-danger" (click)="changeEmail()">{{'lf_register_pin_try_again' |
                        translate}}</p>
                </div>
            </div>
        </div>
    </div>
</div>